import { render } from "./ProjectTRSetting.vue?vue&type=template&id=47599ace&scoped=true"
import script from "./ProjectTRSetting.vue?vue&type=script&lang=js"
export * from "./ProjectTRSetting.vue?vue&type=script&lang=js"

import "./ProjectTRSetting.vue?vue&type=style&index=0&id=47599ace&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47599ace"]])

export default __exports__